module.exports = __webpack_public_path__ + "static/media/Kaggle_logo.199ad3c9.png";